export const apiUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : "https://api.splitta-notan.se";

export const confirmPaymentUrl = "https://splitta-notan.se/confirm-payment";

export const shareLink = "https://splitta-notan.se/r";
